// Sumber tunggal data profil RS (NAP: Name, Address, Phone) + entitas untuk
// structured data (SEO/GEO/AEO). Ubah di sini kalau ada perubahan data.

export const SITE = {
  url: 'https://rsgmiikbw.com',
  name: 'RSGM IIK Bhakti Wiyata',
  legalName: 'Rumah Sakit Gigi dan Mulut IIK Bhakti Wiyata',
  description:
    'Rumah Sakit Gigi dan Mulut IIK Bhakti Wiyata Kediri: layanan dokter gigi umum dan spesialis (konservasi gigi, bedah mulut, prostodonsia, kedokteran gigi anak, ortodonsia, penyakit mulut, periodonsia), rawat jalan, rawat inap, gawat darurat, dan penunjang.',
  telephone: '+62-354-774040',
  alternatePhone: '+62-821-4000-9403',
  faxNumber: '+62-354-771539',
  whatsapp: 'https://wa.me/6282140009403',
  address: {
    street: 'Jl. KH. Wahid Hasyim No. 65',
    locality: 'Kediri',
    region: 'Jawa Timur',
    country: 'ID',
  },
  // Koordinat pasti belum tersedia; sengaja dikosongkan agar tidak menyesatkan.
  // Isi { latitude, longitude } bila sudah pasti untuk boost GEO/local SEO.
  geo: null,
  hasMap:
    'https://www.google.com/maps/search/?api=1&query=RSGM+IIK+Bhakti+Wiyata+Kediri',
  sameAs: [
    'https://www.facebook.com/iikbwkediri',
    'https://www.instagram.com/rsgmiikbw/',
    'https://www.tiktok.com/@rsgmbhakta',
  ],
  // OpeningHoursSpecification (jam operasional RS, dari footer).
  openingHours: [
    {
      days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '08:00',
      closes: '15:00',
    },
    { days: ['Saturday'], opens: '08:00', closes: '12:00' },
  ],
  specialties: [
    'Konservasi Gigi',
    'Bedah Mulut & Maksilofasial',
    'Prostodonsia',
    'Kedokteran Gigi Anak',
    'Ortodonsia',
    'Ilmu Penyakit Mulut',
    'Periodonsia',
  ],
  // Gambar default untuk share sosial (Open Graph / Twitter). File di /static.
  ogImage: '/og-image.png',
};

// Peta hari Indonesia -> schema.org dayOfWeek (Inggris) untuk hoursAvailable.
export const DAY_TO_SCHEMA = {
  Senin: 'Monday',
  Selasa: 'Tuesday',
  Rabu: 'Wednesday',
  Kamis: 'Thursday',
  Jumat: 'Friday',
  Sabtu: 'Saturday',
  Minggu: 'Sunday',
};

// Objek JSON-LD organisasi (Dentist = subtipe MedicalBusiness/LocalBusiness).
// Dipakai di setiap halaman lewat komponen SEO.
export const organizationSchema = () => {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Dentist',
    '@id': `${SITE.url}/#organization`,
    name: SITE.legalName,
    alternateName: SITE.name,
    url: SITE.url,
    logo: `${SITE.url}${SITE.ogImage}`,
    image: `${SITE.url}${SITE.ogImage}`,
    description: SITE.description,
    telephone: SITE.telephone,
    faxNumber: SITE.faxNumber,
    address: {
      '@type': 'PostalAddress',
      streetAddress: SITE.address.street,
      addressLocality: SITE.address.locality,
      addressRegion: SITE.address.region,
      addressCountry: SITE.address.country,
    },
    hasMap: SITE.hasMap,
    sameAs: SITE.sameAs,
    medicalSpecialty: SITE.specialties,
    openingHoursSpecification: SITE.openingHours.map((h) => ({
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: h.days,
      opens: h.opens,
      closes: h.closes,
    })),
  };
  if (SITE.geo) {
    schema.geo = {
      '@type': 'GeoCoordinates',
      latitude: SITE.geo.latitude,
      longitude: SITE.geo.longitude,
    };
  }
  return schema;
};
